'use client';

import { ChangeEvent } from 'react';
import { useRouter } from 'next/navigation';

import { Faq, FaqCategory } from 'src/services/keystone-types';

import FilterByInput from 'src/components/FilterByInput';
import FaqCategories from './FaqCategories';
import FaqCard from './FaqCard';
import { faqUrl } from 'src/services/route-utils';

type Props = {
    items: Faq[];
    categories: FaqCategory[];
    category_slug?: string | null;
};

export default function FaqList({ items, categories, category_slug }: Props) {
    const router = useRouter();

    const handleCategory = (e: ChangeEvent<HTMLSelectElement>) => {
        router.replace(faqUrl({ slug: e.target.value }));
    };

    return (
        <div className="mt-4">
            <div className="mb-8 gap-4 md:flex">
                <FaqCategories categories={categories} value={category_slug || ''} onChange={handleCategory} />
                <div className="flex-1">
                    <FilterByInput id="filter" pathname={''} placeholder="Sau caută după cuvinte cheie" />
                </div>
            </div>

            {items.map((faq) => (
                <FaqCard key={faq.id} faq={faq} />
            ))}
        </div>
    );
}
